<template>
  <div id="app">
    <div class="d-flex h-100 mx-auto flex-column">
      <header class="masthead py-3 mb-auto">
        <b-container>
          <b-link to="/" class="masthead-brand float-left m-0">
            <img :src="logo" alt />
          </b-link>
        </b-container>
      </header>
      <main role="main" class="inner cover">
        <router-view />
      </main>
      <footer class="footer">
        <b-container>
          <p class="text-center">
            &copy; Copyright 2020 Superskill Graphics Pte Ltd. All rights
            Reserved.
          </p>
        </b-container>
      </footer>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import logo from "@/assets/footer-logo.png";
export default {
  name: "Home",
  data() {
    return {
      logo: logo
    };
  }
};
</script>
